import React from "react";

const StartForm = ({ onClick, buttonClicked, progress, t_type }) => {
  return (
    <>
      <div className="wrapper">
        <div className="math-AI-scanning">
          <div className="AI-intro">
            <div className="intro-bg">
              <span className="light-dot dot1-1"></span>
              <span className="light-dot dot2-1"></span>
              <span className="light-dot dot3-1"></span>
              <span className="light-line line1-1"></span>
              <span className="light-line line1-2"></span>
              <span className="light-line line1-3"></span>
              <span className="light-line line2-1"></span>
              <span className="light-line line2-2"></span>
              <span className="light-line line2-3"></span>
            </div>
            <div className="intro-element">
              <h1 className="ie-title">AI스캐닝 수학 진단평가</h1>
              {t_type === "reg-mem" && (
                <div className="top-close">
                  <button
                    className="btn-close"
                    onClick={() => {
                      window.handleConfirm();
                    }}
                  >
                    <i className="icon i-top-close">닫기</i>
                  </button>
                </div>
              )}
              <p className="ie-info">
                가장 진화한 인공지능 도입으로 <br />
                학습자의 향후 수학 능력까지 예측 분석
              </p>
              {buttonClicked ? (
                <>
                  <p className="ie-item">문항 출제 준비 중입니다.</p>
                  <div className="ie-loading">
                    <div className="ai-loading-bar">
                      <span
                        className="loading-current-bar"
                        style={{
                          width: String(progress) + "%",
                          transition: "width 1s linear",
                        }}
                      ></span>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <p className="ie-item">최대 풀이 문항 수 : 15개</p>
                  <div className="ie-button">
                    <button
                      className="button-bottom button-start"
                      onClick={onClick}
                    >
                      분석 시작하기
                    </button>
                  </div>{" "}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StartForm;
